<script setup lang="ts">
import { defineEmits } from "vue";

const emits = defineEmits(["dialogueAction"]);

const dialogueAction = (index: number) => {
  emits("dialogueAction", index);
};
</script>

<template>
  <div class="menu-base">
    <div class="menu-content">
      <div class="menu-item" @click="dialogueAction(0)">
        <el-icon :size="20"><Edit /></el-icon>
        <div>编辑</div>
      </div>
      <div class="menu-item red" @click="dialogueAction(1)">
        <el-icon :size="20"><Delete /></el-icon>
        <div>删除对话</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu-base {
  width: 100%;
  height: auto;
}

.menu-content {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;

  .menu-item {
    padding: 0 8px;
    border-radius: 4px;
    gap: 10px;
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
    justify-content: start;
    font-size: 14px;
    &:hover {
      background-color: #dbeafe;
    }

    cursor: pointer;
  }

  .red {
    color: red;
  }
}
</style>
